import React from "react";
import { Button } from "@porchpass/ui";

interface PreApprovalEmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function PreApprovalEmptyState({
  title,
  description,
  actionLabel,
  onAction,
}: PreApprovalEmptyStateProps) {
  return (
    <div className="flex w-full flex-col items-center justify-center py-16 text-center rounded-xl border border-dashed border-[#E4E7EC] bg-white">
      <p className="font-medium text-[#101827]">{title}</p>
      <p className="text-sm text-[#697083] mt-2 max-w-sm">{description}</p>
      {actionLabel && onAction && (
        <Button
          variant="secondary"
          size="s"
          className="mt-4"
          onClick={onAction}
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
